import { Exchange } from "./exchange-types";
import { Role } from "./user-profile-roles";
import { Status } from "./user-profile-status";
import { Country } from "./country";

export interface UserProfile {
  Id: string;
  Email: string;
  Name: string;
  FamilyName:string;
  UserName:string;
  Phone: string;
  Limit: number;
  Balance: number;
  Role: string;
  Country:string;
  CountryCode:string,
  CurrencyCode:string,
  CurrencySymbol:string,
  CurrencyLabel:string,
  AllowedExchanges : string[];
  CreatedAt : Date;
  CreatedBy:string;
  City : string;
  Status : string;
  Password? : string;
  Address:string,
  ReportsTo:string
}



export class UserProfileFormValues implements Partial<UserProfile>{
  Id='';
  Email='';
  Phone='';
  Name='';
  FamilyName='';
  Limit=0.0;
  Balance=0.0;
  AllowedExchanges=[];
  CreatedAt=new Date();
  CreatedBy='';
  City='';
  Country='';
  Password='';
  Role='';
  Status='';
  Address='';
  UserName='';
  CountryCode='';
  CurrencyCode='';
  CurrencySymbol='';
  CurrencyLabel='';
  ReportsTo='';

  constructor(init?: Partial<UserProfile>) {
    Object.assign(this, init);
  }
}
